<template>
    <KvTable
        :items="noteProps"
        :style="defaultHeight !== undefined && {height:defaultHeight}"
    />
</template>
<script>
    import KvTable from '@/components/Table/kvTable';
    export default {
        props : ['noteProps', 'defaultHeight'],
        components : { KvTable }
    }
</script>